import { render, staticRenderFns } from "./bankerAttitude.vue?vue&type=template&id=774af91c&"
import script from "./bankerAttitude.vue?vue&type=script&lang=js&"
export * from "./bankerAttitude.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports